export const CreateKrSuggestionDrawerNoSuggestionReasonsMap = {
  YOUR_KEY_RESULT_ALREADY_HAS_A_TITLE: "your_key_result_already_has_a_title",
  YOUR_KEY_RESULT_ALREADY_HAS_A_DESCRIPTION: "your_key_result_already_has_a_description",
  ENTER_TITLE_TO_VIEW_SUGGESTIONS: "enter_title_to_view_suggestions",
};
